
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trend-analyzer",
      function () {
        return require("private-next-pages/trend-analyzer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trend-analyzer"])
      });
    }
  